module.exports = __webpack_public_path__ + "static/media/goal-saving.fe4cf118.png";